export default "/images/phone-incoming.svg?9a8b2ff2cf781fcc264d936f211411cf";